import React from 'react';
import SvgTarif from "./icons/Tarif";
import SvgFaitmain from "./icons/Faitmain";
import SvgPersonnalisable from "./icons/Personnalisable";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';

function GiftsComponent() {
    return (
        <section id="section2" className="section section-gifts">

            <Container maxWidth="lg">
                <h1>Des cadeaux uniques et personnalisés</h1>

                <Grid className="gifts" container spacing={2}>
                    <Grid item xs={4}>
                        <SvgFaitmain/>
                        <p>Des objets fait-main de qualité</p>
                    </Grid>
                    <Grid item xs={4}>
                        <SvgTarif/>
                        <p>Des petits prix pour faire plaisir</p>
                    </Grid>
                    <Grid item xs={4}>
                        <SvgPersonnalisable/>
                        <p>Des créations à personnaliser</p>
                    </Grid>
                </Grid>
            </Container>

        </section>
    );
}

export default GiftsComponent;
